import React from 'react';

import WithUnits from 'bundles/apex/deals/form/fields/with_units';
import { getAreaUnitsLabel } from 'bundles/apex/deals/helpers/labels';

const unitOptions = ['sf', 'acres'].map(value => ({
  label: getAreaUnitsLabel(value),
  value: value,
}));

export default function AreaField(props) {
  return <WithUnits {...props} unitOptions={unitOptions} />;
}
